'use client';
import { useLocale } from 'next-intl';
import { usePathname, useRouter } from '@/i18n/navigation';
import s from './LanguageSwitcher.module.css';

interface LanguageSwitcherProps {
  scrolled?: boolean;
}

const LanguageSwitcher = ({ scrolled = false }: LanguageSwitcherProps) => {
  const locale = useLocale();
  const pathname = usePathname();
  const router = useRouter();

  const switchLocale = (newLocale: string) => {
    router.replace(pathname, { locale: newLocale });
  };

  return (
    <div className={`${s.container} ${scrolled ? s.scrolled : ''}`}>
      <button
        className={`${s.btn} ${locale === 'es' ? s.active : ''}`}
        onClick={() => switchLocale('es')}
        aria-label="Español">
        ES
      </button>
      <span className={s.divider}>|</span>
      <button
        className={`${s.btn} ${locale === 'en' ? s.active : ''}`}
        onClick={() => switchLocale('en')}
        aria-label="English">
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
